<template>
    <v-app>
        <!-- Landing page inside phone (screenshotlayer) -->
        <preview-phone v-if="screenshot">
            <router-view class="screenshot-size"/>
        </preview-phone>

        <router-view v-else />
    </v-app>
</template>

<script>
import PreviewPhone from "./components/PreviewPhone";

export default {
    name: "App",
    components: {
        PreviewPhone,
    },
    data() {
        return {
            screenshot: false,
        };
    },
    created() {
        // Check if phone preview (apiscreenshotlayer)
        const urlParams = new URLSearchParams(window.location.search);
        const screenshot = urlParams.get("screenshot");

        if (screenshot) this.screenshot = true;
    },
};
</script>

<style>
#app {
    position: relative;
}

.screenshot-size {
    height: 100%;
}
</style>
